import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetLanguageDescription, useReloadPageOnLanguageChange } from '@dhl/i18n'
import { MenuItem, Select, type SelectProps } from '@dhl-ui/components'

type Props = {
  format?: 'long' | 'short'
  locales: string[]
  onChange?: (locale: string) => void
  reloadPageOnLanguageChange?: boolean
  sx?: SelectProps<string>['sx']
}

export const LanguageSelect: FC<Props> = ({ locales, onChange, reloadPageOnLanguageChange, sx, format = 'long' }) => {
  const { i18n } = useTranslation()
  const getLanguageDescription = useGetLanguageDescription()

  useReloadPageOnLanguageChange(!!reloadPageOnLanguageChange)

  const handleSelectLanguage = (locale: string) => {
    onChange?.(locale)
    i18n.changeLanguage(locale)
  }

  return (
    <Select
      data-testid="language-select"
      size="small"
      sx={sx}
      value={i18n.language}
      onChange={(event) => handleSelectLanguage(event.target.value)}
    >
      {locales.map((locale) => (
        <MenuItem key={locale} value={locale}>
          {getLanguageDescription(locale, format)}
        </MenuItem>
      ))}
    </Select>
  )
}
